export const TRANSPORTS_FILTERS_SET = 'TRANSPORTS_FILTERS_SET';
export const TRANSPORTS_REMOVE_SET = 'TRANSPORTS_REMOVE_SET';
export const TRANSPORTS_REMOVE_LOADING = 'TRANSPORTS_REMOVE_LOADING';
export const TRANSPORTS_SEARCH = 'TRANSPORTS_SEARCH';
